import { AuthTokenStorage } from "../AuthTokenStorage";
import { posthog } from "utils/posthog";

export const UseLogout = (): void => {
    if (posthog.__loaded) posthog.reset();
    AuthTokenStorage.clear();
    window.location.href = "/";
};
